import {
  Caption1,
  mergeClasses
} from '@fluentui/react-components';
import React from 'react';
import { useStyles } from './style';
import type { TimeAndDurationProps } from '../types';

export const TimeAndDuration = ({
  useFormattedTimeAndDuration,
}: TimeAndDurationProps) => {
  const classes = useStyles();
  const [time, duration] = useFormattedTimeAndDuration();

  return (
    <span className={mergeClasses(classes.durationTextContainer, 'clipchamp-player-duration-text')}>
      <Caption1 className={classes.durationText}>
        <span>{time}</span>
        <span className={classes.playerTimeSeparator}>/</span>
        <span>{duration}</span>
      </Caption1>
    </span>
  );
};
